/* jshint ignore:start */
import React from "react";
import VideoItem from "./VideoItem";

const VideoList = (props) => {
    const vItem = props.videos.map((video) => {
      return (
        <VideoItem
          onSelectVItem={props.selectVideo}
          vitem={video}
          key={video.id.videoId}
        />
      );
  })
  return (
    <div>
    {vItem}
    </div>
  );
};

export default VideoList;
